module.exports = __webpack_public_path__ + "media/images/review/star_single-9501d6a9669a879b46dfbe6f6883d8ae.png";